var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.546 5.11094C21.8272 5.39224 21.9852 5.7737 21.9852 6.17144C21.9852 6.56919 21.8272 6.95065 21.546 7.23194L10.303 18.4749C10.1544 18.6236 9.97805 18.7414 9.7839 18.8219C9.58976 18.9023 9.38167 18.9437 9.17153 18.9437C8.96138 18.9437 8.75329 18.9023 8.55915 18.8219C8.365 18.7414 8.1886 18.6236 8.04003 18.4749L2.45403 12.8899C2.31076 12.7516 2.19649 12.5861 2.11787 12.4031C2.03926 12.22 1.99788 12.0232 1.99615 11.824C1.99442 11.6249 2.03237 11.4274 2.10779 11.243C2.18322 11.0587 2.29459 10.8912 2.43543 10.7504C2.57627 10.6095 2.74375 10.4981 2.92809 10.4227C3.11244 10.3473 3.30996 10.3093 3.50913 10.3111C3.7083 10.3128 3.90513 10.3542 4.08813 10.4328C4.27114 10.5114 4.43666 10.6257 4.57503 10.7689L9.17103 15.3649L19.424 5.11094C19.5633 4.97155 19.7287 4.86098 19.9108 4.78554C20.0928 4.7101 20.288 4.67126 20.485 4.67126C20.6821 4.67126 20.8772 4.7101 21.0593 4.78554C21.2413 4.86098 21.4067 4.97155 21.546 5.11094Z",
    fill: "#008CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.c1c3fa70ff3c91d98f43747789d5c337.svg";
export { ForwardRef as ReactComponent };